import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GridPosition } from "./user-settings.slice";
import { Window } from "../../components/DraggableWindow/types";

export interface SerializableIcon {
    type: string;
    color: string;
}

export interface Application {
    id: string;
    name: string;
    iconData: SerializableIcon;
    path: string;
    category: string;
    isPinned: boolean;
    gridPosition?: GridPosition;
    component?: React.ComponentType<{
        window: Window;
        onClose: () => void;
        onMinimize: () => void;
        bringToFront: () => void;
    }>;
}

interface ApplicationsState {
    applications: Application[];
    isLoading: boolean;
    error: string | null;
}

const initialState: ApplicationsState = {
    applications: [],
    isLoading: false,
    error: null,
};

const applicationsSlice = createSlice({
    name: "applications",
    initialState,
    reducers: {
        setApplications: (state, action: PayloadAction<Application[]>) => {
            state.applications = action.payload;
        },
        addApplication: (state, action: PayloadAction<Application>) => {
            state.applications.push(action.payload);
        },
        removeApplication: (state, action: PayloadAction<string>) => {
            state.applications = state.applications.filter((app) => app.id !== action.payload);
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const { setApplications, addApplication, removeApplication, setLoading, setError } = applicationsSlice.actions;
export default applicationsSlice.reducer;
